import numeral from 'numeral'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from './vfs_fonts.js'
pdfMake.vfs = pdfFonts.pdfMake.vfs

numeral.locale('def')

function diff (a, b) {
  if (isNaN(a) || isNaN(b)) {
    return '-'
  }
  return a - b
}

function tonsFloor (val) {
  return (Math.floor(val / 1000) * 1000)
}

function createPdfLayout (state) {
  let mainResult = []
  let inputBody = []
  let numericalBody = []
  let title = {}
  let ingress = {}

  if (state.calculationType === 'energy') {
    title = {
      text: 'Cost savings in drying',
      style: 'calcheader'
    }

    ingress = {
      text: 'The calculation illustrates the likely effect of cake moisture after dewatering on the cost of thermal drying. Effective pressure filtration produces dryer cake compared to centrifuges, which means less thermal drying is required to evaporate the remaining moisture from the cake after dewatering. This reduces the dryer’s operating costs per produced ton of starch. The calculator can be used to estimate costs in certain scenarios, but the inputs must be checked carefully.',
      style: 'calcingress'
    }

    inputBody = [
      {
        table: {
          widths: ['100%'],
          body: [
            [{text: '', style: 'icon', fillColor: '#000000'}]
          ]
        },
        layout: 'noBorders'
      },
      {text: ' '},
      [
        {text: 'General', style: 'valueheader'},
        {text: [
          'Operating hours: ',
          {text: state.operatingHours + ' h', bold: true}
        ],
        style: 'values'},
        {text: [
          'Energy cost: ',
          {text: state.energyCost + ' €/GJ', bold: true}
        ],
        style: 'values'}
      ],
      {text: ' '},
      {
        table: {
          widths: ['100%'],
          body: [
            [{text: '', style: 'icon', fillColor: '#000000'}]
          ]
        },
        layout: 'noBorders'
      },
      {text: ' '},
      [
        {text: 'Process specifications', style: 'valueheader'},
        {text: [
          'Dewatering capacity: ',
          {text: '' + state.dewateringCapacity + ' dry t/h', bold: true}
        ],
        style: 'values'},
        {text: [
          'Dryer efficiency: ',
          {text: '' + state.dryerEfficiency + ' %', bold: true}
        ],
        style: 'values'},
        {text: [
          'Energy required to heat & evaporate 1 kg water: ',
          {text: '' + state.heatEnergyRequired + ' kJ/kg water', bold: true}
        ],
        style: 'values'},
        {text: [
          'Cake moisture after drying: ',
          {text: '' + state.cakeMoistureAfterDryer + ' %', bold: true}
        ],
        style: 'values'}
      ]
    ]

    mainResult = [
      {text: '', style: 'icongreen', fillColor: '#00e2b2'},
      {
        text: [
          {text: numeral(tonsFloor(state.annualSaving)).format('0,0'), style: 'valuesgreen'},
          {text: '\n€ / ANNUM', style: 'unitgreen'}
        ],
        fillColor: '#00e2b2',
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15
      },
      {text: ' '}
    ]

    numericalBody = [
      [
        {text: 'Type', style: 'valuetable', fillColor: '#090909', marginLeft: 10, color: 'white'},
        {text: 'As is', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Upgrade', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Value', style: 'valuetable', fillColor: '#090909', color: 'white'}
      ],
      [
        {text: 'Feed to dryer (wet cake)', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.dryerFeed)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((state.upgradedResults.dryerFeed)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((diff(state.currentResults.dryerFeed, state.upgradedResults.dryerFeed))).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'}
      ],
      [
        {text: 'Output from the dryer', style: 'valuetable', fillColor: '#E6E6E6', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.dryerOutput)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((state.upgradedResults.dryerOutput)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((diff(state.currentResults.dryerOutput, state.upgradedResults.dryerOutput))).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#E6E6E6'}
      ],
      [
        {text: 'Water evaporated in the dryer', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.evaporation)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((state.upgradedResults.evaporation)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((diff(state.currentResults.evaporation, state.upgradedResults.evaporation))).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'}
      ],
      [
        {text: 'Energy required', style: 'valuetable', fillColor: '#E6E6E6', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.energyRequired)).format('0,0') + ' GJ', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((state.upgradedResults.energyRequired)).format('0,0') + ' GJ', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((diff(state.currentResults.energyRequired, state.upgradedResults.energyRequired))).format('0,0') + ' GJ', style: 'valuetable', fillColor: '#E6E6E6'}
      ],
      [
        {text: 'Cost per year', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.costPerYear)).format('0,0') + ' €', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((state.upgradedResults.costPerYear)).format('0,0') + ' €', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral((diff(state.currentResults.costPerYear, state.upgradedResults.costPerYear))).format('0,0') + ' €', style: 'valuetable', fillColor: '#f8f8f8'}
      ]
    ]
  } else if (state.calculationType === 'speed') {
    title = {
      text: 'Throughput increase in drying',
      style: 'calcheader'
    }

    ingress = {
      text: 'The calculation illustrates the potential increase in capacity through a thermal dryer when the cake moisture is reduced. Effective pressure filtration produces dryer cake compared to centrifuges, which means less drying is needed and the throughput of the dryer increases.',
      style: 'calcingress'
    }

    inputBody = [
      {
        table: {
          widths: ['100%'],
          body: [
            [{text: '', style: 'icon', fillColor: '#000000'}]
          ]
        },
        layout: 'noBorders'
      },
      {text: ' '},
      [
        {text: 'Process specifications', style: 'valueheader'},
        {text: [
          'Cake moisture after dewatering:',
          {text: '' + state.cakeMoisture + ' %', bold: true}
        ],
        style: 'values'},
        {text: [
          'Dryer capacity: ',
          {text: '' + state.dryerCapacity + ' dry t/h', bold: true}
        ],
        style: 'values'},
        {text: [
          'Cake moisture after drying: ',
          {text: '' + state.cakeMoistureAfterDryer + ' %', bold: true}
        ],
        style: 'values'}
      ]
    ]

    mainResult = [
      {text: '', style: 'icongreen', fillColor: '#00e2b2'},
      {
        text: [
          {text: numeral(state.productionIncrease).format('0.00'), style: 'valuesgreen'},
          {text: '\n%', style: 'unitgreen'}
        ],
        fillColor: '#00e2b2',
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15
      },
      {text: ' '}
    ]

    numericalBody = [
      [
        {text: 'Type', style: 'valuetable', fillColor: '#090909', marginLeft: 10, color: 'white'},
        {text: 'As is', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Upgrade', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Value', style: 'valuetable', fillColor: '#090909', color: 'white'}
      ],
      [
        {text: 'Annual throughput', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral(state.currentResults.annualThroughput).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(state.upgradedResults.annualThroughput).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(diff(state.upgradedResults.annualThroughput, state.currentResults.annualThroughput)).format('0,0') + ' t/a', style: 'valuetable', fillColor: '#f8f8f8'}
      ],
      [
        {text: 'Tonnes water to be evaporated', style: 'valuetable', fillColor: '#E6E6E6', marginLeft: 10},
        {text: ' ' + numeral(state.currentResults.evaporatedWater).format('0.00') + ' t/h', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral(state.upgradedResults.evaporatedWater).format('0.00') + ' t/h', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral(diff(state.currentResults.evaporatedWater, state.upgradedResults.evaporatedWater)).format('0.00') + ' t/h', style: 'valuetable', fillColor: '#E6E6E6'}
      ],
      [
        {text: 'Dryer capacity', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral(state.dryerCapacity).format('0.00') + ' dry t/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(state.increasedDryerCapacity).format('0.00') + ' dry t/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(diff(state.increasedDryerCapacity, state.dryerCapacity)).format('0.00') + ' dry t/h', style: 'valuetable', fillColor: '#f8f8f8'}
      ]
    ]
  } else {
    title = {
      text: 'Starch yield increase',
      style: 'calcheader'
    }

    ingress = {
      text: 'The calculation illustrates reduced product losses to waste by taking the mass balance across the dewatering equipment. Pressure filters produce extremely clear filtrate, meaning less starch is lost to waste and more starch is available for packing. This calculation does not include the additional cost of treating the waste solids in the treatment plant.',
      style: 'calcingress'
    }

    inputBody = [
      {
        table: {
          widths: ['100%'],
          body: [
            [{text: '', style: 'icon', fillColor: '#000000'}]
          ]
        },
        layout: 'noBorders'
      },
      {text: ' '},
      [
        {text: 'General', style: 'valueheader'},
        {text: [
          'Operating hours: ',
          {text: state.operatingHours + ' h', bold: true}
        ],
        style: 'values'},
        {text: [
          'Selling price of product: ',
          {text: state.sellingPrice + ' €/t', bold: true}
        ],
        style: 'values'}
      ],
      {text: ' '},
      {
        table: {
          widths: ['100%'],
          body: [
            [{text: '', style: 'icon', fillColor: '#000000'}]
          ]
        },
        layout: 'noBorders'
      },
      {text: ' '},
      [
        {text: 'Process specifications', style: 'valueheader'},
        {text: [
          'Dewatering capacity: ',
          {text: '' + state.dewateringCapacity + ' dry t/h', bold: true}
        ],
        style: 'values'},
        {text: [
          'Wash water consumption: ',
          {text: '' + state.washWater + ' m³', bold: true}
        ],
        style: 'values'},
        {text: [
          'Solids in filtrate/centrate: ',
          {text: '' + state.solidsContent + ' ppm', bold: true}
        ],
        style: 'values'},
        {text: [
          'Cake moisture after dewatering: ',
          {text: '' + state.cakeMoisture + '%', bold: true}
        ],
        style: 'values'}
      ]
    ]

    mainResult = [
      {text: '', style: 'icongreen', fillColor: '#00e2b2'},
      {
        text: [
          {text: numeral(tonsFloor(state.wasteReduction)).format('0,0'), style: 'valuesgreen'},
          {text: '\n€ / ANNUM', style: 'unitgreen'}
        ],
        fillColor: '#00e2b2',
        marginTop: 15,
        marginBottom: 15,
        marginLeft: 15
      },
      {text: ' '}
    ]

    numericalBody = [
      [
        {text: 'Type', style: 'valuetable', fillColor: '#090909', marginLeft: 10, color: 'white'},
        {text: 'As is', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Upgrade', style: 'valuetable', fillColor: '#090909', color: 'white'},
        {text: 'Value', style: 'valuetable', fillColor: '#090909', color: 'white'}
      ],
      [
        {text: 'Total liquid (filtrate + wash filtrate)', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral(state.currentResults.liquid).format('0.00') + ' m³/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(state.upgradedResults.liquid).format('0.00') + ' m³/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(diff(state.currentResults.liquid, state.upgradedResults.liquid)).format('0.00') + ' m³/h', style: 'valuetable', fillColor: '#f8f8f8'}
      ],
      [
        {text: 'Total solids in this liquid', style: 'valuetable', fillColor: '#E6E6E6', marginLeft: 10},
        {text: ' ' + numeral(state.currentResults.solidsInLiquid).format('0.00') + ' kg/h', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral(state.upgradedResults.solidsInLiquid).format('0.00') + ' kg/h', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral(diff(state.currentResults.solidsInLiquid, state.upgradedResults.solidsInLiquid)).format('0.00') + ' kg/h', style: 'valuetable', fillColor: '#E6E6E6'}
      ],
      [
        {text: 'Value of solids lost in filtrate (€/h) ', style: 'valuetable', fillColor: '#f8f8f8', marginLeft: 10},
        {text: ' ' + numeral(state.currentResults.lostSolidsPerHour).format('0.00') + ' €/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(state.upgradedResults.lostSolidsPerHour).format('0.00') + ' €/h', style: 'valuetable', fillColor: '#f8f8f8'},
        {text: ' ' + numeral(diff(state.currentResults.lostSolidsPerHour, state.upgradedResults.lostSolidsPerHour)).format('0.00') + ' €/h', style: 'valuetable', fillColor: '#f8f8f8'}
      ],
      [
        {text: 'Value of solids lost in filtrate (€/a) ', style: 'valuetable', fillColor: '#E6E6E6', marginLeft: 10},
        {text: ' ' + numeral((state.currentResults.lostSolids)).format('0,0') + ' €/a', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((state.upgradedResults.lostSolids)).format('0,0') + ' €/a', style: 'valuetable', fillColor: '#E6E6E6'},
        {text: ' ' + numeral((diff(state.currentResults.lostSolids, state.upgradedResults.lostSolids))).format('0,0') + ' €/a', style: 'valuetable', fillColor: '#E6E6E6'}
      ]
    ]
  }

  let docDef = {
    pageSize: 'A4',
    pageOrientation: 'portrait',
    pageMargins: [ 20, 40, 20, 40 ],
    defaultStyle: {
      font: 'Din'
    },
    content: [
      {table: {
        widths: ['100%'],
        body: [
          [{text: 'Value calculation', style: 'header', marginLeft: 20, marginRight: 20}],
          [{text: 'for starch dewatering solution', style: 'header', marginLeft: 20, marginRight: 20}]
        ]
      },
      layout: {
        hLineWidth: function (i, node) {
          return 0
        },
        hLineColor: function (i, node) {
          return 0
        },
        vLineWidth: function (i, node) { return 0 }
      },
      paddingLeft: 20,
      paddingRight: 20
      },
      {table: {
        widths: ['100%'],
        body: [
          [{text: '', lineHeight: 0, fontSize: 0}]
        ]
      },
      layout: {
        hLineWidth: function (i, node) {
          if (i === 0) { return 0 }
          return 0
        },
        hLineColor: function (i, node) {
          return 0
        },
        vLineWidth: function (i, node) { return 0 }
      },
      marginLeft: 20,
      marginRight: 20,
      marginBottom: 5
      },
      {table: {
        widths: ['48%', '4%', '16%', '16%', '16%'],
        body: [
          [
            {text: 'Save energy, reduce wash water consumption, and increase plant capacity with Metso Larox® PF pressure filters for starch dewatering and washing. Larox PF pressure filters and life cycle services for native and modified starches in industrial food and pharmaceutical applications are based on our decades of experience and proven track record.', style: 'ingress'},
            {text: ' '},
            {svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g fill="#6e6c70" data-name="CC-090 (Maximized) Throughput"><path d="M15.06 24.84a1.51 1.51 0 0 0 .51 2.94 1.49 1.49 0 0 0 .5-.08 1.52 1.52 0 0 0 .93-1.93 1.52 1.52 0 0 0-1.94-.93zm.68 1.91a.51.51 0 0 1-.66-.31.53.53 0 0 1 .31-.66h.17a.51.51 0 0 1 .49.34.51.51 0 0 1-.31.63zM20.73 26a1.8 1.8 0 0 0 .5-.08 1.5 1.5 0 0 0 .86-.78 1.48 1.48 0 0 0 .07-1.14 1.55 1.55 0 0 0-.78-.87 1.53 1.53 0 0 0-1.15-.13 1.51 1.51 0 0 0 .5 2.94zm-.17-2a.47.47 0 0 1 .17 0 .59.59 0 0 1 .27 0 .51.51 0 0 1 .26.3.48.48 0 0 1 0 .39.5.5 0 0 1-.29.26.52.52 0 0 1-.66-.31.53.53 0 0 1 .25-.64zM9.87 26.66a1.53 1.53 0 0 0-.86.78A1.48 1.48 0 0 0 9 28.59a1.53 1.53 0 0 0 1.93.93 1.52 1.52 0 0 0 .92-1.93 1.52 1.52 0 0 0-1.98-.93zm.68 1.92a.56.56 0 0 1-.4 0 .53.53 0 0 1-.26-.29.48.48 0 0 1 0-.39.54.54 0 0 1 .29-.27h.17a.51.51 0 0 1 .49.34.53.53 0 0 1-.29.61zM25.23 24a1.52 1.52 0 0 0 .66.15 1.43 1.43 0 0 0 .5-.09 1.45 1.45 0 0 0 .86-.77 1.48 1.48 0 0 0 .07-1.15 1.52 1.52 0 0 0-1.93-.93 1.48 1.48 0 0 0-.86.77 1.5 1.5 0 0 0 .7 2zm.49-1.85a.51.51 0 0 1 .17 0 .51.51 0 0 1 .48.35.5.5 0 0 1-.31.65.51.51 0 1 1-.34-1zM30.4 22.2a1.47 1.47 0 0 0 .65.15 1.43 1.43 0 0 0 .5-.09 1.51 1.51 0 1 0-1-2.85 1.45 1.45 0 0 0-.86.77 1.5 1.5 0 0 0-.07 1.16 1.53 1.53 0 0 0 .78.86zm.19-1.59a.53.53 0 0 1 .29-.26h.17a.52.52 0 0 1 .49.35.51.51 0 0 1-.32.65.48.48 0 0 1-.39 0 .51.51 0 0 1-.26-.3.49.49 0 0 1 .02-.44zM35.71 17.6a1.51 1.51 0 1 0 1.93.92 1.5 1.5 0 0 0-1.93-.92zm.68 1.91a.52.52 0 0 1-.35-1h.17a.51.51 0 0 1 .49.34.53.53 0 0 1-.31.66zM3.117 27.588l.944-.331.331.943-.943.332zM5.003 26.927l.943-.332.332.944-.943.332zM6.58 31.413l.944-.331.33.943-.943.331zM4.699 32.08l.943-.33.331.943-.943.331zM15 39.51h1v1h-1zM15 41.51h1v1h-1zM18.37 39.51h1v1h-1zM18.37 41.51h1v1h-1z"/><path d="M36 26.5a9.33 9.33 0 0 0-2.88.46v-3.79l5.2-1.82a2.88 2.88 0 0 0 1.76-3.67 2.89 2.89 0 0 0-3.67-1.77l-.43.15-3.91-7.46-6 3.65.78 7-4.8 1.68 1-2L17 13.59l-5.54 7.94 4.28 1.63-6.96 2.44-1.89.66.33.94 1.89-.66 27.6-9.69A1.88 1.88 0 1 1 38 20.41l-27.6 9.68-1.88.67.33.94 1.84-.7L15 29.52v9h1v-.73l2.37-1.53v2.26h1V28l9.35-3.28v5.16A9.49 9.49 0 1 0 36 26.5zm-5.65-12l-2.78-1.92 3.62-2.21zm-.38.95l-2.17 2.87-.53-4.73zm1.12.19l1-4.82L35 16.4l-6.18 2.16zm-12 3.51l-1-3.27 3.29 2.87zm0 1l2.53-.45-.87 1.73-2.62.92zm-2.19-4.69l1.26 4.19-1.25 2.89L13 21.05zM32 27.37l-1.89-1.21 2-1.25v2.43zm-1 .54a10.32 10.32 0 0 0-1.3.95v-1.78zm-12.63 6.51l-1.95-1.25 1.95-1.26zM16 34.09l2 1.25-2 1.25zm0-1.85v-2.5L18 31zm2.37-2.16L16.62 29l1.75-.61zm13.72-6.55v.19l-2.37 1.53v-.89zM36 44.5a8.5 8.5 0 0 1-3.78-16.11A8.37 8.37 0 0 1 36 27.5a8.5 8.5 0 0 1 0 17z"/><path d="M29.87 35.41l.7.7 1.73-1.73v5.72h1v-5.72l1.73 1.73.71-.7-2.94-2.94-2.93 2.94zM39.14 30.77L36.2 33.7l.71.71 1.73-1.73v7.42h1v-7.42l1.73 1.73.71-.71-2.94-2.93z"/></g></svg>', width: 60},
            {svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g fill="#6e6c70" data-name="CC-093 (Reduced) Energy Consumption"><path d="M9.04 14.91h7.57v1H9.04zM10.33 17.12h1v1h-1zM14.33 17.12h1v1h-1zM12.33 17.12h1v1h-1z"/><path d="M36 26.5h-.48v-7.11a6.8 6.8 0 0 0-13.6 0V31a3.8 3.8 0 1 1-7.59 0v-6.5H15v-2.08L18.7 19v-6.46H17V8.47a1.36 1.36 0 0 0-1.35-1.35h-.25a1.36 1.36 0 0 0-1.35 1.35v4.07h-2.44V8.47a1.36 1.36 0 0 0-1.35-1.35h-.21A1.36 1.36 0 0 0 8.7 8.47v4.07H7V19l3.71 3.45v2.05h.66V31a6.8 6.8 0 1 0 13.59 0V19.39a3.8 3.8 0 0 1 7.6 0v7.78A9.48 9.48 0 1 0 36 26.5zm-24.33-3.8H14v.8h-2.33zm3.38-14.23a.35.35 0 0 1 .35-.35h.21a.35.35 0 0 1 .35.35v4.07h-.91zm-5.35 0a.35.35 0 0 1 .35-.35h.21a.35.35 0 0 1 .35.35v4.07H9.7zM8 13.54h9.7v5l-3.4 3.16h-2.93L8 18.53zm20.72 1.06a4.81 4.81 0 0 0-4.8 4.79V31a5.8 5.8 0 1 1-11.59 0v-6.5h1V31a4.8 4.8 0 1 0 9.59 0V19.39a5.8 5.8 0 0 1 11.6 0v7.24a8.05 8.05 0 0 0-1 .21v-7.45a4.81 4.81 0 0 0-4.8-4.79zM36 44.5a8.5 8.5 0 1 1 8.5-8.5 8.51 8.51 0 0 1-8.5 8.5z"/><path d="M39.82 39.14l-2.4-3.34h-3.31L32 31.69l-.89.45 2.39 4.66h3.41l2.44 3.39h-2.68v1h4.15v-4.16h-1v2.11z"/></g></svg>', width: 60},
            {svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><g fill="#6e6c70"><path d="M30.18 7.56h-1l.12 3.16-.44-.4-.62.79c.17.13.33.29.49.43l-3.29.16v1l4.88-.23zm-1 4l.18-.17v.16zM18.15 25.09v-.75c0-2.57-8.27-2.57-8.27 0v3.16H9.4c-2.06 0-4.14.67-4.14 2V36c0 1.29 2.08 2 4.14 2a5.85 5.85 0 0 0 .59 0c.44 1 2.24 1.49 4 1.49s3.67-.54 4.05-1.56a9.54 9.54 0 0 0 1.33.11c2.05 0 4.13-.67 4.13-2V27c.03-1.59-3-2.23-5.35-1.91zm-7.27 2.73a7 7 0 0 0 3.14.65 6.93 6.93 0 0 0 3.13-.65v.88c0 .27-1.1.95-3.13.95s-3.14-.68-3.14-.95zm0 4.36a7.11 7.11 0 0 0 3.14.65 7.07 7.07 0 0 0 3.13-.65v.88c0 .27-1.1.95-3.13.95s-3.14-.68-3.14-.95zm3.12-.35c-2 0-3.14-.68-3.14-.95V30a7.11 7.11 0 0 0 3.14.65 7.07 7.07 0 0 0 3.15-.65v.88c0 .27-1.1.95-3.15.95zm-3.14 2.53A7.11 7.11 0 0 0 14 35a7.07 7.07 0 0 0 3.13-.65v.88c0 .27-1.1.95-3.13.95s-3.14-.68-3.14-.95zm3.14-11c2 0 3.13.68 3.13 1s-1.1.95-3.13.95-3.14-.68-3.14-.95 1.14-.98 3.14-.98zm-3.14 2.26a7 7 0 0 0 3.14.65 6.93 6.93 0 0 0 3.13-.65v.88c0 .27-1.1.95-3.13.95s-3.14-.68-3.14-.95zM9.4 28.47h.48v1.85H9.4c-2 0-3.14-.68-3.14-1s1.1-.85 3.14-.85zm-3.14 2.26a7.11 7.11 0 0 0 3.14.65h.48v1.18H9.4c-2 0-3.14-.68-3.14-1zm0 2.18a7.11 7.11 0 0 0 3.14.65h.48v1.18H9.4c-2 0-3.14-.68-3.14-1zm0 3.05v-.87a7.11 7.11 0 0 0 3.14.65h.48v1.18H9.4c-2.04 0-3.14-.68-3.14-.92zM14 38.37c-2 0-3.14-.68-3.14-.95v-.88a7.11 7.11 0 0 0 3.14.65 7.07 7.07 0 0 0 3.13-.65v.88c.02.27-1.08.95-3.13.95zm5.38-1.45a8.42 8.42 0 0 1-1.25-.11v-1.17a8.44 8.44 0 0 0 1.25.1 7.07 7.07 0 0 0 3.13-.65V36c.02.24-1.08.92-3.11.92zm0-2.18a8.3 8.3 0 0 1-1.25-.11v-1.17a8.44 8.44 0 0 0 1.25.1 7.07 7.07 0 0 0 3.13-.65v.87c.02.28-1.08.96-3.11.96zm0-2.18a8.3 8.3 0 0 1-1.25-.11v-1.17a8.44 8.44 0 0 0 1.25.1 7.07 7.07 0 0 0 3.13-.65v.87c.02.28-1.08.96-3.11.96zm0-2.18a8.3 8.3 0 0 1-1.25-.11V29.1a8.44 8.44 0 0 0 1.25.1 7.07 7.07 0 0 0 3.13-.65v.87c.02.28-1.08.96-3.11.96zm0-2.18a8.42 8.42 0 0 1-1.25-.11v-2A7.27 7.27 0 0 1 19.4 26c2 0 3.13.68 3.13.95v.29c0 .28-1.1.96-3.13.96zM28.69 15.57v6.54c0 1.28 2.08 1.95 4.14 1.95 1.78 0 3.57-.5 4-1.48a8.15 8.15 0 0 0 1.75.2c2.06 0 4.14-.68 4.14-2v-4.32c0-1.72-3.76-2.28-6.13-1.72-1.59-1.74-7.9-1.42-7.9.83zm1 1.3a7 7 0 0 0 3.14.65 6.93 6.93 0 0 0 3.17-.65v.88c0 .28-1.1.95-3.13.95s-3.14-.67-3.14-.95zm0 2.18a7 7 0 0 0 3.14.65 6.93 6.93 0 0 0 3.17-.65v.88c0 .28-1.1.95-3.13.95s-3.14-.67-3.14-.95zm3.14 4c-2 0-3.14-.67-3.14-.95v-.88a7 7 0 0 0 3.14.65 6.93 6.93 0 0 0 3.17-.64v.88c0 .28-1.14.95-3.17.95zm5.77-1.28a7.61 7.61 0 0 1-1.6-.18v-1.16a8.59 8.59 0 0 0 1.64.17 7.11 7.11 0 0 0 3.1-.6v.87c0 .23-1.1.91-3.14.91zm0-2.18a7.61 7.61 0 0 1-1.6-.18v-1.16a8.18 8.18 0 0 0 1.64.17 7.11 7.11 0 0 0 3.14-.65v.87c-.04.28-1.14.96-3.18.96zm3.14-3.14c0 .28-1.1 1-3.14 1a7.18 7.18 0 0 1-1.6-.22V15.7a7 7 0 0 1 1.64-.19c2 0 3.1.68 3.1.95zm-8.91-1.84c2 0 3.13.67 3.13 1s-1.1.95-3.13.95-3.14-.67-3.14-.95 1.1-.99 3.14-.99zM21.86 9.05H22v-1h-1.04l.07 1zM18.26 9.64l-.32-1a10.28 10.28 0 0 0-1 .38l.41.92c.32-.08.65-.2.91-.3z"/><path d="M28 9.76a10.36 10.36 0 0 0-.92-.52l-.44.9a8.2 8.2 0 0 1 .82.46zM20.12 9.18l-.15-1a9 9 0 0 0-1 .21l.24 1c.28-.1.59-.16.91-.21zM12.22 19.25v-.95h-1c0 .34 0 .69.05 1zM16.53 10.42L16 9.55a8.25 8.25 0 0 0-.88.57l.58.81a7.68 7.68 0 0 1 .83-.51zM23 9.1c.32 0 .64.08.95.14l.19-1a9.3 9.3 0 0 0-1-.15zM12.33 16.39l-1-.17a9 9 0 0 0-.13 1l1 .08c.04-.3.08-.6.13-.91zM26.13 8.82c-.33-.12-.66-.23-1-.33l-.27 1c.31.08.61.18.91.29zM13.74 12.93l-.81-.58a10.4 10.4 0 0 0-.56.9l.88.48a9 9 0 0 1 .49-.8zM15 11.52l-.67-.74a10.46 10.46 0 0 0-.75.74l.75.67a7.06 7.06 0 0 1 .67-.67zM12.85 14.58l-.93-.38c-.13.32-.24.66-.34 1l1 .27a7.76 7.76 0 0 1 .27-.89zM36 26.49A9.5 9.5 0 1 0 45.5 36a9.52 9.52 0 0 0-9.5-9.51zm0 18A8.5 8.5 0 1 1 44.5 36a8.51 8.51 0 0 1-8.5 8.49z"/><path d="M40.85 34.34l-.65-1.29.43-1.76-2.35-1.49-1.4 1.14-1.22-.05-1.3-1.25-2.47 1.3.29 1.76-.75 1-1.76.46-.19 2.78 1.67.69.66 1.29-.44 1.76 2.36 1.49L35.12 41l1.48.06 1.3 1.25L40.37 41l-.3-1.79.55-1 1.72-.45.19-2.76zm.54 2.66l-1.39.4-1 1.67.23 1.42-1.19.63-1-1-2.25-.12-1.14.92-1.13-.72.35-1.42-1-1.95-1.35-.56.1-1.27 1.4-.37L33.24 33 33 31.49l1.2-.63 1.05 1 2 .07 1.1-.93 1.14.72-.35 1.42 1 1.95 1.35.56z"/><path d="M36.2 33a3 3 0 0 0-.4 6h.2a3 3 0 0 0 .2-6zm-.33 5a2 2 0 0 1 .13-4h.14a2 2 0 0 1-.27 4z"/></g></svg>', width: 60}
          ]
        ]
      },
      style: 'ingresstable',
      layout: 'noBorders',
      marginLeft: 20,
      marginRight: 20},
      title,
      ingress,

      {table: {
        widths: ['10%', '2%', '36%', '4%', '10%', '2%', '36%'],
        body: [inputBody]
      },
      style: 'uservaluetable',
      layout: 'noBorders',
      marginLeft: 20,
      marginRight: 20},
      {table: {
        widths: ['12%', '32%', '56%'],
        body: [
          mainResult
        ]
      },
      style: 'moneytable',
      layout: 'noBorders',
      marginLeft: 20,
      marginRight: 20
      },
      {table: {
        widths: ['*', '17%', '17%', '17%'],
        body: numericalBody
      },
      style: 'valuestable',
      layout: 'noBorders',
      marginLeft: 20,
      marginRight: 20},
      {
        text: 'All values and figures seen in the above value calculation are intended for information purposes only and cannot be taken as a guarantee or binding to Metso in any way. Currency and market fluctuations will not be updated in real time economic gain and environmental benefits are only to be seen as indicative to our clientele.',
        style: 'legal',
        marginLeft: 20,
        marginRight: 20
      }
    ],
    footer: [
      {table: {
        widths: ['50%', '50%'],
        body: [
          [
            { text: 'metso.com', style: 'subheader', marginLeft: 40 },
            { svg: "<svg version='1.1' width='74px' height='20px' xmlns='http://www.w3.org/2000/svg' xml:space='preserve'><g id='Logo'><path id='svg_1' d='m66.40966,4.4753c-4.49544,0 -6.90144,3.35575 -6.90144,7.72455c0,4.3688 2.40601,7.78787 6.90144,7.78787c4.49544,0 6.90144,-3.35575 6.90144,-7.78787c0,-4.43212 -2.46932,-7.72455 -6.90144,-7.72455m0,12.40993c-2.34269,0 -3.60901,-1.70953 -3.60901,-4.7487c0,-2.65927 0.94974,-4.68538 3.60901,-4.68538c2.34269,0 3.60901,1.5829 3.60901,4.68538c0,3.1658 -1.26632,4.7487 -3.60901,4.7487'/><path id='svg_2' d='m40.51342,15.04907l0,-7.40797l4.24217,0l0,-2.91254l-4.24217,0l0,-4.7487l-3.22912,0l0,15.63905c0,2.65927 1.64622,4.30549 4.30549,4.30549c1.51958,0 2.7859,-0.3799 3.79896,-0.88642l-0.82311,-2.72259c-1.5829,0.75979 -4.11554,1.07637 -4.05222,-1.26632'/><path id='svg_3' d='m28.61001,4.4753c-4.05222,0 -6.58486,3.67233 -6.58486,7.66124c0,4.30549 2.40601,7.78787 6.90144,7.78787c2.02611,0 4.17886,-0.75979 5.69844,-2.08943l-1.51958,-2.40601c-1.07637,0.94974 -2.34269,1.5829 -4.05222,1.5829c-2.08943,0 -3.60901,-1.64622 -3.79896,-3.41906l9.87729,0c0,-0.50653 0.06332,-1.01306 0.06332,-1.51958c0,-4.87533 -2.40601,-7.59792 -6.58486,-7.59792m-3.29243,6.39492c0.18995,-2.53264 1.89948,-3.60901 3.29243,-3.60901c2.02611,0 3.22912,1.26632 3.29243,3.5457l0,0.06332l-6.58486,0z'/><path id='svg_4' d='m53.93641,10.80689l-2.34269,-0.44321c-1.13969,-0.25326 -1.64622,-0.69648 -1.64622,-1.51958c0,-1.26632 1.45627,-1.70953 2.72259,-1.70953c1.203,0 2.46932,0.31658 3.60901,1.07637l1.51958,-2.40601c-1.32964,-0.82311 -3.10248,-1.39295 -5.19191,-1.39295c-3.10248,0 -5.82507,1.51958 -5.82507,4.68538c0,2.34269 1.32964,3.67233 4.05222,4.24217l2.34269,0.44321c1.13969,0.25326 1.5829,0.75979 1.5829,1.64622c0,1.01306 -0.82311,1.70953 -2.40601,1.70953c-1.13969,0 -2.53264,-0.31658 -4.05222,-1.70953l-1.70953,2.27938c1.32964,1.45627 3.48238,2.21606 5.76176,2.21606c3.10248,0 5.69844,-1.51958 5.69844,-4.68538c-0.06332,-2.59596 -1.51958,-3.92559 -4.11554,-4.43212'/><polygon id='svg_5' points='9.995112136006355,13.466163635253906 3.6635131388902664,-0.020140886306762695 0.24444825947284698,-0.020140886306762695 0.24444825947284698,19.734453201293945 3.536880448460579,19.734453201293945 3.536880448460579,6.691356182098389 8.538844779133797,17.328445434570312 11.45138044655323,17.328445434570312 16.453345015645027,6.691356182098389 16.453345015645027,19.734453201293945 19.809090331196785,19.734453201293945 19.809090331196785,-0.020140886306762695 16.39002676308155,-0.020140886306762695'/></g></svg>", width: 74, marginRight: 20, alignment: 'right' }
          ]
        ]
      },
      layout: 'noBorders'}
    ],
    styles: {
      ingresstable: {
        margin: [0, 10, 0, 10]
      },
      header: {
        fontSize: 30,
        font: 'DinCond',
        bold: true
      },
      headerSymbol: {
        fontSize: 20,
        font: 'DinCond',
        bold: true
      },
      ingress: {
        fontSize: 9,
        alignment: 'justify',
        lineHeight: 1.1
      },

      calcheader: {
        fontSize: 12,
        font: 'DinCond',
        marginRight: 20,
        marginLeft: 20,
        bold: true,
        marginBottom: 7
      },
      calcingress: {
        fontSize: 9,
        font: 'DinCond',
        lineHeight: 1.1,
        marginRight: 20,
        marginLeft: 20,
        marginBottom: 20
      },

      uservaluetable: {
        margin: [0, 5, 0, 20]
      },
      icon: {
        alignment: 'center',
        marginTop: 12,
        marginBottom: 12,
        marginRight: 12,
        marginLeft: 12,
        color: 'white',
        fontSize: 22,
        font: 'fontawesome'
      },
      valueheader: {
        fontSize: 10,
        font: 'Din',
        marginBottom: 2,
        bold: true
      },
      values: {
        fontSize: 9
      },
      subheader: {
        fontSize: 12,
        font: 'Din',
        margin: [0, 0, 0, 10]
      },

      moneytable: {
        margin: [0, 0, 0, 10]
      },
      icongreen: {
        marginTop: 20,
        marginLeft: 17,
        alignment: 'center',
        color: 'black',
        font: 'fontawesome',
        fontSize: 36
      },
      icongreendin: {
        marginTop: 15,
        alignment: 'center',
        color: 'black',
        font: 'Din',
        fontSize: 20
      },
      valuesgreen: {
        font: 'Din',
        fontSize: 32,
        color: 'black',
        bold: true
      },
      unitgreen: {
        fontSize: 10,
        color: 'black'
      },

      valuestable: {
        margin: [0, 0, 0, 10]
      },
      valuetable: {
        marginTop: 4,
        lineHeight: 1.4,
        fontSize: 10,
        color: 'black'
      },
      legal: {
        fontSize: 8,
        alignment: 'justify',
        color: '#8B8C8E'
      },
      footer: {
        fontSize: 8,
        color: '#8B8C8E'
      }
    }
  }
  return docDef
}

export function makePdf (state) {
  console.log('make pdf')
  let docDefinition = createPdfLayout(state)
  pdfMake.fonts = {
    fontawesome: {
      normal: 'fontawesome-webfont.ttf',
      bold: 'fontawesome-webfont.ttf',
      italics: 'fontawesome-webfont.ttf',
      bolditalics: 'fontawesome-webfont.ttf'
    },
    Din: {
      normal: 'GT-Eesti-Pro-Text-Regular.ttf',
      bold: 'GT-Eesti-Pro-Text-Regular.ttf',
      italics: 'GT-Eesti-Pro-Text-Regular.ttf',
      bolditalics: 'GT-Eesti-Pro-Text-Regular.ttf'
    },
    DinCond: {
      normal: 'GT-Eesti-Pro-Text-Regular.ttf',
      bold: 'GT-Eesti-Pro-Text-Regular.ttf',
      italics: 'GT-Eesti-Pro-Text-Regular.ttf',
      bolditalics: 'GT-Eesti-Pro-Text-Regular.ttf'
    }
  }

  console.log('working?')
  pdfMake.createPdf(docDefinition).download('Metso-Starch-Calculation.pdf')
  return 'sent'
}



// WEBPACK FOOTER //
// ./src/starch-pdf.js